import type { CatalogBrandItemDTO, TenantBrandViewDTO } from '@today/types'
import { apiClient } from './api.client'

const adminBase = (tenantId: string) => `/admin/tenants/${encodeURIComponent(tenantId)}/brand`

/** Tenant brand selection (TO-380): the catalogue and a tenant's brand, per console plane. */
export const tenantBrandService = {
	/** `GET /admin/brands` — Super-Admin. */
	async listCatalog(): Promise<CatalogBrandItemDTO[]> {
		const { data } = await apiClient.get<{ items: CatalogBrandItemDTO[] }>('/admin/brands')
		return data.items
	},

	/** `GET /admin/tenants/{tenantId}/brand` — Super-Admin, any tenant. */
	async getPlatform(tenantId: string): Promise<TenantBrandViewDTO> {
		const { data } = await apiClient.get<TenantBrandViewDTO>(adminBase(tenantId))
		return data
	},

	/** `GET /t/{slug}/admin/brand` — the caller's own tenant, read-only. */
	async getTenant(slug: string): Promise<TenantBrandViewDTO> {
		const { data } = await apiClient.get<TenantBrandViewDTO>(`/t/${encodeURIComponent(slug)}/admin/brand`)
		return data
	},

	/** `PUT /admin/tenants/{tenantId}/brand` — Super-Admin. */
	async select(tenantId: string, brandId: string): Promise<TenantBrandViewDTO> {
		const { data } = await apiClient.put<TenantBrandViewDTO>(adminBase(tenantId), { brandId })
		return data
	},
}
